module.exports = "<% if (small) { %>\n<div class=\"pic-wrap is-small\" style=\"max-width: <%= width %>px; max-height: <%= height %>px;\">\n<% } else { %>\n<div class=\"pic-wrap is-big\">\n<% } %>\n    <div class=\"img-container\" style=\"<%= percent?'padding-bottom: ' + percent : ''  %>\">\n        <div class=\"x-img-wrap G-img-wrap is-loading\">\n            <img <%= lazy? 'class=\"x-lazy\" data-':'' %>src=\"<%= src %>\" <%= srcHD?'data-pic=\"' + srcHD + '\"':''%> onload=\"__imgLoaded(this)\" onerror=\"__imgError(this)\" alt=\"\">\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/HTMLTag/image.ejs
// module id = 10
// module chunks = 0